var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', [_c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "400"
    }
  }, [_c('v-card-title', [_vm._v(" 참여코드를 입력하세요. ")]), _c('v-card-text', [_c('v-text-field', _vm._b({
    ref: "code-input",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input, {
    errorMessages: _vm.errorMessages
  }), false))], 1), _c('v-card-actions', [_c('v-row', [_c('v-col', [_c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("취소")])], 1), _c('v-col', [_c('v-btn', _vm._b({
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.exec
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("참여하기")])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }